import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../../core/data/redux/store';
import {createEsicDisablementType,updateEsicDisablementType,fetchEsicDisablementTypeList,deleteEsicDisablementType} from '../../../../core/data/redux/payroll/ESIC/Master/Disablement/disablementAction';
import { Drawer, message } from 'antd';
import DeleteModal1 from '../../../../core/modals/deleteModal1';

const DisablementModal: React.FC<any> = ({
  handleCancel,
  isModalVisible,
  modalType,
  selectedRowData,
  disablementData,
  setDisablementData,
  setTableKey,
  setIsDeleteModalVisible,
  isDeleteModalVisible,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { loading } = useSelector((state: any) => state.esic.disablement);

  const [errors, setErrors] = useState<any>({});

  const resetForm = () => {
    setDisablementData({
      disablement_type: '',
      description: '',
    });
    setErrors({});
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, field: string) => {
    const value = e.target.value;
    setDisablementData({ ...disablementData, [field]: value });
    setErrors((prev: any) => ({ ...prev, [field]: '' }));
  };

  const validateForm = () => {
    let formIsValid = true;
    let newErrors: any = {};

    if (!disablementData.disablement_type) newErrors.disablement_type = 'Disablement Type is required.';

    if (Object.keys(newErrors).length > 0) {
      formIsValid = false;
    }
    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) return;

    const payload = { ...disablementData };

    try {
      let result;
      if (modalType === 'create') {
        result = await dispatch(createEsicDisablementType(payload)).unwrap();
      } else if (modalType === 'edit' && selectedRowData) {
        result = await dispatch(
          updateEsicDisablementType({ id: selectedRowData.disablement_id, payload })
        ).unwrap();
      }
      console.log("result",result)
      if (result) {
        message.success(result?.message || 'Saved successfully');
        await dispatch(fetchEsicDisablementTypeList());
        setTableKey((prev: any) => prev + 1);
        resetForm();
        handleCancel();
      }
    } catch (error: any) {
      message.error(error.error || 'An error occurred');
    }
  };

  const handleDelete = async (id: number) => {
    try {
      const result = await dispatch(deleteEsicDisablementType(id));
      if (result.meta.requestStatus === 'fulfilled') {
        message.success('Deleted successfully');
        await dispatch(fetchEsicDisablementTypeList());
        setTableKey((prev: any) => prev + 1);
        setIsDeleteModalVisible(false);
      } else {
        message.warning('Delete failed');
      }
    } catch {
      message.error('Something went wrong');
    }
  };

  return (
    <>
      <Drawer
        title={modalType === 'edit' ? 'Edit Disablement Type' : 'Add Disablement Type'}
        placement="right"
        width={600}
        onClose={() => {
          handleCancel();
          resetForm();
        }}
        open={isModalVisible}
        style={{ marginTop: 50, paddingBottom: 50 }}
      >
        <form onSubmit={handleSubmit}>
          <div className="modal-body pb-0">
            {/* Disablement Type */}
            <div className="mb-3">
              <label className="form-label">
                Disablement Type <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={disablementData.disablement_type}
                onChange={(e) => handleInputChange(e, 'disablement_type')}
              />
              {errors.disablement_type && <div className="text-danger">{errors.disablement_type}</div>}
            </div>

            {/* Description */}
            <div className="mb-3">
              <label className="form-label">Description</label>
              <textarea
                className="form-control"
                rows={3}
                value={disablementData.description}
                onChange={(e) => handleInputChange(e, 'description')}
              />
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-white border me-2"
              onClick={() => {
                resetForm();
                handleCancel();
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading && <span className="spinner-border spinner-border-sm me-2" />}
              {modalType === 'edit' ? 'Update Disablement' : 'Add Disablement'}
            </button>
          </div>
        </form>
      </Drawer>

      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() => selectedRowData?.disablement_id && handleDelete(selectedRowData.disablement_id)}
      />
    </>
  );
};

export default DisablementModal;
